module.exports = __webpack_public_path__ + "assets/img/Type E (56).8edbf03f.jpg";